var prefixClassName = function prefixClassName(className) {
  return "ads-".concat(className);
};
var scopeClassName = function scopeClassName(className) {
  return "a42df" ? "a42df".concat("-", className) : className;
};

export { prefixClassName, scopeClassName };
//# sourceMappingURL=scopeClassName.js.map
